// extracted by mini-css-extract-plugin
module.exports = {"flex":"flex--fF0uw","box":"box--veExW","title":"title--mglSM"};